// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"edfb8723","513":"460c409f","703":"40160e4b","787":"96abe4e0"}[chunkId] + ".chunk.js";
};